module.exports = __webpack_public_path__ + "img/spaced-dot-vertical.4d7997d3.svg";